module.exports = __webpack_public_path__ + "files/00bfa19cecc3900646c108e4ac706488.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/Source-Sans-Pro-regular.woff2
 ** module id = 879
 ** module chunks = 0
 **/